'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = require('@progress/kendo-base-components-vue-wrapper');

var _MultiSelectProps = require('./MultiSelectProps');

var _MultiSelectProps2 = _interopRequireDefault(_MultiSelectProps);

var _Animation = require('../Common/Animation');

var _Animation2 = _interopRequireDefault(_Animation);

var _Popup = require('../Common/Popup');

var _Popup2 = _interopRequireDefault(_Popup);

var _Virtual = require('../Common/Virtual');

var _Virtual2 = _interopRequireDefault(_Virtual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _MultiSelectProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Animation2.default, _Popup2.default, _Virtual2.default],
    mounted: function mounted() {
        var that = this;
        var widgetElement = that.$el;

        kendo.jQuery(widgetElement).kendoMultiSelect(that.widgetOptions);

        if (this.v3) {
            this.ready();
        }

        that.$emit('kendowidgetready', that.kendoWidget());

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', that.kendoWidget().value());
            } else {
                that.$emit('changemodel', that.kendoWidget().value());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            var widgetElement = this.$el;

            return kendo.jQuery(widgetElement).getKendoMultiSelect();
        }
    },
    model: {
        event: 'changemodel'
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-dropdowns-vue-wrapper/dist/es/KendoMultiSelect/KendoMultiSelectMixin.js
// module id = VqpB
// module chunks = 40